export default __webpack_public_path__ + "static/Emerging-Technologies-banner-1a3a8dcf99700d88d65dbf739a5e8202.webp";